var map = {
	"./arg.svg": 2333,
	"./aus.svg": 2334,
	"./bel.svg": 2335,
	"./bra.svg": 2336,
	"./can.svg": 2337,
	"./cmr.svg": 2338,
	"./crc.svg": 2339,
	"./cro.svg": 2340,
	"./den.svg": 2341,
	"./ecu.svg": 2342,
	"./eng.svg": 2343,
	"./esp.svg": 2344,
	"./fra.svg": 2345,
	"./ger.svg": 2346,
	"./gha.svg": 2347,
	"./irn.svg": 2348,
	"./jpn.svg": 2349,
	"./kor.svg": 2350,
	"./ksa.svg": 2351,
	"./mar.svg": 2352,
	"./mex.svg": 2353,
	"./ned.svg": 2354,
	"./pol.svg": 2355,
	"./por.svg": 2356,
	"./qat.svg": 2357,
	"./sen.svg": 2358,
	"./srb.svg": 2359,
	"./sui.svg": 2360,
	"./tun.svg": 2361,
	"./uru.svg": 2362,
	"./usa.svg": 2363,
	"./wal.svg": 2364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;